<div class="profile-page-content">
  <router-outlet />
</div>
